import { render, staticRenderFns } from "./licensing.vue?vue&type=template&id=d7fa1fb6&scoped=true&"
import script from "./licensing.vue?vue&type=script&lang=js&"
export * from "./licensing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fa1fb6",
  null
  
)

export default component.exports